jQuery(document).ready(function(){
    var $ = jQuery;
    var storyCarousels = $(".story-carousel .slider-container");
    $(storyCarousels).each(function(){
        $(this).slick({
            arrows: true,
            infinite: false,
            prevArrow: '<button type="button" class="slick-prev"><span class="arrowIcon"></span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="arrowIcon"></span></button>'
        });
    });
});